export const backgrounds = {
  beton_hell_600_600_60: {
    bg: 'beton-hell-600x600-60.jpg',
    theme: '',
  },
  beton_neutral: {
    bg: 'beton-neutral.jpg',
    theme: 'cms-dark-theme',
  },
  beton: {
    bg: 'beton.jpg',
    theme: 'cms-dark-theme',
  },
  erde: {
    bg: 'erde.jpg',
    theme: 'cms-dark-theme',
  },
  holzoptik: {
    bg: 'holzoptik.jpg',
    theme: 'cms-dark-theme',
  },
  holzplatte: {
    bg: 'holzplatte.jpg',
    theme: 'cms-dark-theme',
  },
  kork: {
    bg: 'kork.jpg',
    theme: 'cms-dark-theme',
  },
  pflasterstein: {
    bg: 'pflasterstein.jpg',
    theme: 'cms-dark-theme',
  },
  rasen: {
    bg: 'rasen.jpg',
    theme: 'cms-dark-theme',
  },
  putz: {
    bg: 'putz.jpg',
    theme: 'cms-dark-theme',
  },
  beton_neutral_300x300_80: {
    bg: 'beton-neutral-300x300-80.jpg',
    theme: 'cms-dark-theme',
  },
  beton_300x300_60: {
    bg: 'beton-300x300-60.jpg',
    theme: 'cms-dark-theme',
  },
  erde_300x300_50: {
    bg: 'erde-300x300-50.jpg',
    theme: 'cms-dark-theme',
  },
  holz_300x300_80: {
    bg: 'holz-300x300-80.jpg',
    theme: 'cms-dark-theme',
  },
  kork_300x300_20: {
    bg: 'kork-300x300-20.jpg',
    theme: 'cms-dark-theme',
  },
  pflaster_300x300_40: {
    bg: 'pflaster-300x300-40.jpg',
    theme: 'cms-dark-theme',
  },
  putz_300x300_50: {
    bg: 'putz-300x300-50.jpg',
    theme: 'cms-dark-theme',
  },
  rasen_300x300_20: {
    bg: 'rasen-300x300-20.jpg',
    theme: 'cms-dark-theme',
  },
  fliese_holzoptik_300x300_40: {
    bg: 'fliese-holzoptik-300x300-40.jpg',
    theme: 'cms-dark-theme',
  },
  no_background: {
    bg: '',
    theme: '',
  },
  bg_blau: {
    bg: 'bg_blau.jpg',
    theme: 'cms-dark-theme',
  },
  bg_estrich_dunkel: {
    bg: 'bg_estrich_dunkel.jpg',
    theme: 'cms-dark-theme',
  },
  bg_estrich_hell: {
    bg: 'bg_estrich_hell.jpg',
    theme: 'cms-light-grey-theme',
  },
  bg_holz: {
    bg: 'bg_holz.jpg',
    theme: 'cms-dark-theme',
  },
  bg_orange: {
    bg: 'bg_orange.jpg',
    theme: 'cms-dark-theme',
  },
  bg_rasen: {
    bg: 'bg_rasen.jpg',
    theme: 'cms-dark-theme',
  },
};
